import { z } from 'zod';
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.string(),
    version: z.string(),
    time: z.iso.datetime(),
});
//# sourceMappingURL=health.js.map